import React, { useMemo, useRef } from 'react';
import { injectIntlAndObserver, IRouterWithIntl } from '../../../../utils';
import { onChangeReportId } from '../../@data/actions';
import { TythonColumnsEnum } from '../../@data/store/schema/ColumnsEnum';
import { ICustomCalenderDateRange } from '../../components/CustomCalender/CustomCalender.types';
import { IReportsMetadata } from '../../DashboardCards/@data/store/schema';
import { ReportCard } from '../../DashboardCards/ReportCard/ReportCard';
import { constructPubCenterReportingRequestBody } from '../../DashboardCards/ReportCard/ReportCard.helpers';
import { ChartGrain, ReportCardType } from '../../DashboardCards/ReportCard/ReportCard.types';
import { aggregateReportData } from '../../DetailPage/utils/utils';
import { usePubCenterReportMetadata, usePubCenterReportQuery } from '../../hooks/useReportQuery';
import message from '../OverviewPage.messages';
import { ALLOWED_CHARTS, DEFAULT_ACTIVE_METRICS, DEFAULT_GRANULARITY, DEFAULT_METRICS } from '../utils/constants';

export interface IPubCenterReportCardProps extends IRouterWithIntl {
  dateRange: ICustomCalenderDateRange;
  reportType: ReportCardType;
}

export const PubCenterChartCard = injectIntlAndObserver((props: IPubCenterReportCardProps) => {
  const reportCardRef = useRef<HTMLDivElement>(null);

  const {
    reportType,
    dateRange,
    match,
    history,
    location,
    intl: { formatMessage },
  } = props;

  const { data: metadata, isLoading: isMetaDataLoading } = usePubCenterReportMetadata(reportType, true);

  const { data } = usePubCenterReportQuery(
    constructPubCenterReportingRequestBody(reportType, reportType, dateRange, DEFAULT_GRANULARITY[reportType] ?? ChartGrain.DAILY, {}, [
      ...(DEFAULT_METRICS[reportType] ?? []),
    ]),
    true
  );

  const { data: summaryData } = usePubCenterReportQuery(
    constructPubCenterReportingRequestBody(reportType, reportType, dateRange, ChartGrain.NONE, {}, [
      ...(DEFAULT_METRICS[reportType] ?? []),
    ]),
    true
  );

  const METADATA: IReportsMetadata = useMemo(
    () => ({
      dimensions: [...(metadata?.dimensions || [])],
      metrics: [
        ...[...(DEFAULT_METRICS[reportType] ?? [])].map((metric) => ({
          key: metric,
          displayName: metric,
          filterKey: metric,
          incompatibleFields: [],
        })),
      ],
      grains: [],
      isMetadataLoaded: !isMetaDataLoading,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [metadata, reportType]
  );

  return (
    <ReportCard
      legend
      match={match}
      title={formatMessage(message[reportType])}
      dateRange={dateRange}
      history={history}
      location={location}
      reportMetadata={{ ...METADATA }}
      type={reportType}
      allowedChartTypes={ALLOWED_CHARTS[reportType] ?? []}
      allowedChartGrains={[]}
      showDetailsReportLink
      isDetailedView={false}
      filters={[]}
      reportCardRef={reportCardRef}
      dateDimension={TythonColumnsEnum.Date}
      dataMetrics={{ chartDataMetrics: `${reportType} Card ID` }}
      reportData={data?.Data}
      defaultColumns={[]}
      defaultMetrics={[...(DEFAULT_ACTIVE_METRICS[reportType] ?? [])]}
      showMetricsMarkers
      summaryData={summaryData ? summaryData.Data : aggregateReportData(data?.Data)}
      reportDetailedData={data?.Data}
      onViewReportClick={() => {
        onChangeReportId(reportType, history);
      }}
      isPubCenterChart
    />
  );
});
